import { customSWRConfig, customSWRResponse } from '../../model/types';
import useSingleCompanySetting from './useSingleCompanySetting';

export default function useCompanyTimeZone(config: customSWRConfig = {}): customSWRResponse<string> {
    const { data, error, isLoading } = useSingleCompanySetting('TIMEZONE', config);

    return {
        data: data ? data.value : (data as undefined),
        error,
        isLoading
    };
}
